import { FC, PropsWithChildren } from 'react';
import Typography from '@carrot-deprecated/typography';

export const FormFieldLabel: FC<PropsWithChildren> = ({ children }) => {
  return <Typography variant="inputLabel">{children}</Typography>;
};
